module.exports = __webpack_public_path__ + "img/picture_34.222731fd.png";